<template>
<div class="cardPay">
  <div>
    <div class="head">
      <span class="s-16">金额(¥)</span>
      <input type="text" placeholder="请输入充值金额" name="" v-model="money">
      <span class="s-14" v-if="offer>0">送{{offer}}元</span>
    </div>
    <div class="list">
      <h1>充值优惠<span>可直接选择</span></h1>
      <ul>
        <li v-for="(item, index) in list" :class="index === moneyIndex ? 'active' : ''" @click="choose(index)">
          <p class="s-18">{{item.storeMoney}}元</p>
          <p class="s-14">送{{item.giveMoney}}元</p>
        </li>
      </ul>
    </div>
  </div>
  <!-- <div>
    <div class="head m-10" v-if="getdatanull(money)">
      <span class="s-16">金额(¥)</span>
      <input type="text" relative  v-model="money" name="">
    </div>
  </div> -->
  <div class="pay" v-show="payType == 'weixin' || payType == 'alipay'">
    <h1>支付方式</h1>
    <ul>
      <li v-show="payType == 'weixin'">
        <img class="fl" src="../../images/icon/wx.png">
        微信
        <img class="fr" src="../../images/icon/check1.png">
      </li>
      <li v-show="payType == 'alipay'">
        <img class="fl" src="../../images/icon/zfb.png">
        支付宝
        <img class="fr" src="../../images/icon/check1.png">
      </li>
    </ul>
  </div>
  <div class="cardBut">
    <span class="active" @click="prePayOrder">确认支付 <font v-if="getdatanull(money)">¥{{money}}</font></span>
  </div>
  <div class="popups" v-show="landingShow">
    <div class="mask">
      <div class="landing">
        <h2>绑定手机号</h2>
        <div class="msgs">
          <div class="text-enter">
            <div class="landedText username">
              <input @blur="fixScroll" name="username" placeholder="请输入手机号" type="text" v-model="phone">
            </div>
            <div class="landedText password">
              <input @blur="fixScroll" type="password" name="password" placeholder="验证码" v-model="authCode">
              <span class="pas-but" @click="codeSendMes()" v-if="but">获取验证码</span>
              <span class="pas-but" v-else>{{timerCodeMsg}}</span>
            </div>
          </div>
        </div>
        <div class="but clearfix">
          <ul>
            <li @click="landingShow=false">取消</li>
            <li class="red" @click="submit()">确定</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import api from '@/fetch/api'
export default {
  name: 'storePay',
  data () {
    return {
      moneyIndex:'',
      money:'', //输入金额
      offer:0,  //优惠金额
      payType: '',
      list:[],
      landingShow:false,
      timerCodeMsg: '', //点击获取验证码
      phone: '', //手机号码
      authCode: '', //验证码
      but: true, //验证码按钮
      storeDiscountNo:'',
      getmerData : localStorage.getItem('mre_'+ this.$route.query.shopAlias)
    }
  },
  created() {
    this.init();
  },
  methods: {
    fixScroll() {  //兼容微信 页面上划
      window.scrollTo(0, 0);
    },
    init () {
      this.getPayWay();
      let data = {
        loginShopAlias:this.$route.query.shopAlias,
      }
      api.findStoreDiscountDetail(data)
      .then(res => {
        this.list = res.resultObj;
      }, res => {
        this.$toast(res.resultMsg);
      })
    },
    choose(val){  //选择充值金额
    console.log("val")
   console.log(val)
      this.moneyIndex = val;
      this.money = '';
      this.offer = 0;
      this.money = this.list[val].storeMoney
      this.offer = this.list[val].giveMoney
      this.storeDiscountNo = this.list[val].discountNo
      console.log(this.storeDiscountNo)
    },
    getPayWay() {
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信浏览器
        this.payType = 'weixin';

      } else if(ua.match(/alipay/i) == "alipay") {
        //支付宝浏览器
        this.payType = 'alipay';

      } else {
        this.payType = 3;
        this.$messagebox.alert('请使用微信或支付宝打开','提示')
      }

    },
    prePayOrder(){ //生成订单
      if(this.money >0 && this.money < 99999.99) {
        let data = {
          loginShopAlias:this.$route.query.shopAlias,
          storeMoney:this.money,
          payType:this.payType,
          subPayType:'',
          storeDiscountNo:this.storeDiscountNo? this.storeDiscountNo : '',
          casherAlias: this.getmerData ? this.getmerData : ''
        }
        console.log(data)
        api.generateStoreOrder(data)
        .then(res => {
          localStorage['storeOrderNo'] = res.resultObj.storeOrderNo;
          this.pay(res.resultObj.storeOrderNo);
        }, res => {
          if(res.resultCode == 28003){  //判断是否绑定手机号码
            this.landingShow = true
          }else if(res.resultCode == 28002){ //成为会员 - 已有手机号码
            this.goMember()
          }else{
            this.$toast(res.resultMsg);
          }
        })
      }else{
        this.$toast('金额输入范围0.01-99999.99');
      }
    },
    pay(orderNo){ //提交订单--获取唤醒支付的参数
      this.$indicator.open();
      let data = {
        loginShopAlias:this.$route.query.shopAlias,
        payType:this.payType,
        storeOrderNo:orderNo
      }
      api.storeCardFillPrePay(data)
      .then(res => {
        this.$indicator.close();
        this.goOrderPay(this.payType,res)
      }, res => {
        this.$indicator.close();
        this.$toast(res.resultMsg);
      })
    },
    codeSendMes() { //请求验证码
				let reg = /^1\d{10}$/;
				if(this.phone == '') {
					this.$toast({
						message: '请输入手机号码',
						position: 'bottom',
						duration: 2000
					});
				} else if(!reg.test(this.phone)) {
					this.$toast({
						message: '手机格式不正确',
						position: 'bottom',
						duration: 2000
					});
				} else {
					this.but = false;
					let sec = 60;
					let _this = this;
					for(let i = 0; i <= 60; i++) {
						window.setTimeout(function() {
							if(sec != 0) {
								_this.timerCodeMsg = sec + "秒";
								sec--;
							} else {
								sec = 60; //如果倒计时结束就让  获取验证码显示出来
								_this.but = true;
							}
						}, i * 1000)
          }
          let data = {
            phone:this.phone,
            sceneCode:'memberLogin'
          }
					api.phonemethods(data).then(res => {
						return
					}, res => {
						this.but = true;
						this.$toast({
							message: res.resultMsg,
							position: 'bottom',
							duration: 2000
						});
					});
				}
      },
      submit() { //成为会员
				let reg = /^1\d{10}$/;
				if(this.phone == '') {
					this.$toast({
						message: '请输入手机号码',
						position: 'bottom',
						duration: 2000
					});
				} else if(!reg.test(this.phone)) {
					this.$toast({
						message: '手机格式不正确',
						position: 'bottom',
						duration: 2000
					});
				} else if(this.authCode == '') {
					this.$toast({
						message: '请输入验证码',
						position: 'bottom',
						duration: 2000
					});

				} else {

					//if(!localStorage.token) {
          let data = {
            "newPhone": this.phone,
            "authCode": this.authCode
          }
					api.combineWithPhone(data)
						.then(res => {
              this.landingShow = false
              this.goMember()
						}, res => {
							this.$toast({
								message: res.resultMsg,
								position: 'bottom',
								duration: 2000
							});
						})
					//}
					// api.addshopcashier(this.loginShopAlias,this.phone,this.authCode);
				}
      },
      goMember(val){  //成为会员 - 已有手机号码
        let data = {
          'loginShopAlias':this.$route.query.shopAlias,
        }
        api.joinShopMember(data)
          .then(res => {
            //成为会员  直接购买
            this.prePayOrder()
          }, res => {
            this.$toast({
              message: res.resultMsg,
              position: 'bottom',
              duration: 2000
            });
          })
      },

  },
   watch: {
      '$route': function () {
      	this.init();
      },
      money(val, oldVal){//金额监听
        console.log(val)
        var rex=/^\d{1,5}(|(\.\d{0,2}))$/; //小数点前5位小数点后两位
        if(rex.test(val)){
          if(this.list.length > 0){
            if(val < this.list[0].storeMoney){
              this.offer = 0
              this.money = val
              return
            }
            for (var i=0;i<this.list.length; i++) {
              if(val >= this.list[i].storeMoney){
                this.offer = this.list[i].giveMoney
                this.storeDiscountNo = this.list[i].discountNo
                this.money = val
              }
            }
          }else{
            this.offer = 0
            this.money = val
          }
        }else{
          this.money = this.money.substr(0, this.money.length - 1)
          return
        }
      },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pay/storepay.vue